export default __webpack_public_path__ + "static/media/tiktok-icon.207c28c0.png";